import Fuse from "fuse.js";
import formatDistance from 'date-fns/formatDistance'
import _orderBy from "lodash.orderby"
import _filter from "lodash.filter"

export const standards = state => state.standards

export const showSearch = state => state.showSearch

export const searchTerm = state => state.searchTerm

export const entries = (state, getters) => {
	if (state.entries.length > 0) {
		let ent = state.entries ? state.entries.map(entry => {
			entry.formattedUpdatedDate = formatDistance(new Date(), new Date(entry.updated_at))
			entry.formattedCreatedDate = formatDistance(new Date(), new Date(entry.created_at))
			return entry
		}) : []

		if (getters.searchTerm.length > 1) {
			let entries = ent.filter(entry => {
				return entry.title.toUpperCase()
					.concat(entry.excerpt ? entry.excerpt.toUpperCase() : '')
					.concat(entry.section ? entry.section.toUpperCase(): '')
					// .concat(entry.body.toUpperCase())
					.includes(getters.searchTerm.toUpperCase());
			}).sort((a, b) => {
				return a.created_at < b.created_at ? 1 :
					b.created_at < a.created_at ?
					-1 :
					0
			});

			let categories = state.categories.filter(category => {
				return category.name.toUpperCase()
					.concat(category.related_terms ? category.related_terms.toUpperCase() : '')
					.includes(getters.searchTerm.toUpperCase());
			})

			return entries.concat(categories)
		}

		return ent
	} else {
		return []
	}

}

export const filteredStandards = (state, getters) => {
	let standards = getters.standards;

	let options = {
		threshold: 0.25,
		distance: 400,
		maxPatternLength: 10,
		keys: [{
			name: "status",
			weight: 0.09
		}, {
			name: "year",
			weight: 0.09
		}, {
			name: "desc",
			weight: 0.09
		}, {
			name: "title",
			weight: 0.18
		}, {
			name: "product",
			weight: 0.16
		}, {
			name: "type",
			weight: 0.16
		}, {
			name: "sector",
			weight: 0.09
		}, {
			name: "categories",
			weight: 0.14
		}]
	};
	let fuse = new Fuse(standards, options);
	standards = fuse.search(getters.standardsSearchTerm);

	if (getters.sortKey) {
		standards = _orderBy(
			standards, [getters.sortKey], [getters.sortOrder]
		)
	}
	standards = getters.showWithdrawn ? standards : _filter(standards, {
		"status": "Current"
	})
	return standards;
}

export const hasStandards = (state, getters) => {
	return (
		Object.keys(getters.standards).length != 0 &&
		getters.standards.constructor != Object
	);
}

export const standardsCount = (state, getters) => {
	return getters.hasStandards ? getters.filteredStandards.length : 0;
}

export const standardsSearchTerm = state => state.standardsSearchTerm
export const sortOrder = state => state.sortOrder
export const sortKey = state => state.sortKey

export const showWithdrawn = state => state.showWithdrawn

export const members = state => state.members
